import React from "react";

const PriceSlider = ({ maxPrice, selectedPriceRange, handlePriceChange, currencySymbol }) => {
  // Price bounds are always whole numbers: floor the min and ceil the max so no
  // product is excluded from its own range by rounding.
  const integerMaxPrice = Math.ceil(Number(maxPrice) || 0);
  const [rawMinPrice = 0, rawMaxRangePrice = integerMaxPrice] = selectedPriceRange || [];
  const minPrice = Math.floor(Number(rawMinPrice) || 0);
  const maxRangePrice = Math.ceil(Number(rawMaxRangePrice) || 0);

  const handleSliderChange = (e) => {
    const index = Number(e.target.dataset.index);
    const newValue = [minPrice, maxRangePrice];
    newValue[index] = index === 0
      ? Math.floor(Number(e.target.value))
      : Math.ceil(Number(e.target.value));

    // Ensure min is always less than max
    if (newValue[0] > newValue[1]) return;

    handlePriceChange(e, newValue);
  };

  return (
    <div className="price-slider relative w-full h-6 flex flex-col">
      {/* Price Track */}
      <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-300 rounded-lg -translate-y-1/2"></div>

      {/* Selected Price Range Track */}
      <div
        className="absolute top-1/2 h-1 bg-gray-600 rounded-lg -translate-y-1/2"
        style={{
          left: `${(minPrice / integerMaxPrice) * 100}%`,
          right: `${100 - (maxRangePrice / integerMaxPrice) * 100}%`,
        }}
      ></div>

      {/* Two Range Inputs for Dual Handles */}
      <input
        type="range"
        min={0}
        max={integerMaxPrice}
        step={1}
        value={minPrice}
        data-index="0"
        onChange={handleSliderChange}
        className="absolute w-full h-2 bg-transparent appearance-none cursor-pointer"
        style={{ zIndex: 2 }}
      />
      <input
        type="range"
        min={0}
        max={integerMaxPrice}
        step={1}
        value={maxRangePrice}
        data-index="1"
        onChange={handleSliderChange}
        className="absolute w-full h-2 bg-transparent appearance-none cursor-pointer"
        style={{ zIndex: 1 }}
      />

      {/* Min & Max Price Display */}
      <div className="flex justify-between text-sm text-gray-700 mt-4">
        <span>{`${currencySymbol}${minPrice}`}</span>
        <span>{`${currencySymbol}${maxRangePrice}`}</span>
      </div>
    </div>
  );
};

export default PriceSlider;
